export const USER_COUNT_REQUEST = "USER_COUNT_REQUEST";
export const USER_COUNT_SUCCESS = "USER_COUNT_SUCCESS";
export const USER_COUNT_FAIL = "USER_COUNT_FAIL";

export const ADMIN_COUNT_REQUEST = "ADMIN_COUNT_REQUEST";
export const ADMIN_COUNT_SUCCESS = "ADMIN_COUNT_SUCCESS";
export const ADMIN_COUNT_FAIL = "ADMIN_COUNT_FAIL";

export const ARTISAN_COUNT_REQUEST = "ARTISAN_COUNT_REQUEST";
export const ARTISAN_COUNT_SUCCESS = "ARTISAN_COUNT_SUCCESS";
export const ARTISAN_COUNT_FAIL = "ARTISAN_COUNT_FAIL";

export const PRODUCT_COUNT_REQUEST = "PRODUCT_COUNT_REQUEST";
export const PRODUCT_COUNT_SUCCESS = "PRODUCT_COUNT_SUCCESS";
export const PRODUCT_COUNT_FAIL = "PRODUCT_COUNT_FAIL";

export const ARTISAN_PRODUCT_COUNT_REQUEST = "ARTISAN_PRODUCT_COUNT_REQUEST";
export const ARTISAN_PRODUCT_COUNT_SUCCESS = "ARTISAN_PRODUCT_COUNT_SUCCESS";
export const ARTISAN_PRODUCT_COUNT_FAIL = "ARTISAN_PRODUCT_COUNT_FAIL";

export const ORDER_COUNT_REQUEST = "ORDER_COUNT_REQUEST";
export const ORDER_COUNT_SUCCESS = "ORDER_COUNT_SUCCESS";
export const ORDER_COUNT_FAIL = "ORDER_COUNT_FAIL";

export const ORDER_PAID_COUNT_REQUEST = "ORDER_PAID_COUNT_REQUEST";
export const ORDER_PAID_COUNT_SUCCESS = "ORDER_PAID_COUNT_SUCCESS";
export const ORDER_PAID_COUNT_FAIL = "ORDER_PAID_COUNT_FAIL";

export const ORDER_DELIVERED_COUNT_REQUEST = "ORDER_DELIVERED_COUNT_REQUEST";
export const ORDER_DELIVERED_COUNT_SUCCESS = "ORDER_DELIVERED_COUNT_SUCCESS";
export const ORDER_DELIVERED_COUNT_FAIL = "ORDER_DELIVERED_COUNT_FAIL";

export const USER_REPORT_COUNT_REQUEST = "USER_REPORT_COUNT_REQUEST";
export const USER_REPORT_COUNT_SUCCESS = "USER_REPORT_COUNT_SUCCESS";
export const USER_REPORT_COUNT_FAIL = "USER_REPORT_COUNT_FAIL";